import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Users, TrendingUp, Award } from 'lucide-react';

const Onboarding = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: 'Build Your Network, Earn Unlimited',
      description: 'Create a powerful network and earn passive income through our proven 5×10 matrix system',
      icon: Users,
      color: 'primary',
    },
    {
      title: '5×10 Matrix System',
      description: 'Each member can refer up to 5 people directly. Earn commissions across 10 levels with rates from 10% to 1%',
      icon: TrendingUp,
      color: 'success',
    },
    {
      title: 'Two Powerful Plans',
      description: 'Prime: ₹1L minimum, 6% monthly returns\nPremium: ₹5L minimum, 10% monthly returns',
      icon: Award,
      color: 'warning',
    },
  ];

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      localStorage.setItem('onboarding_completed', 'true');
      navigate('/login');
    }
  };

  const handleSkip = () => {
    localStorage.setItem('onboarding_completed', 'true');
    navigate('/login');
  };

  const slide = slides[currentSlide];
  const Icon = slide.icon;

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-light via-white to-success-light flex flex-col">
      {/* Skip Button */}
      <div className="flex justify-end p-4">
        <button
          onClick={handleSkip}
          className="text-gray-600 font-medium text-sm"
        >
          Skip
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
        <div className={`w-32 h-32 rounded-full bg-${slide.color}-light flex items-center justify-center mb-8`}>
          <Icon className={`w-16 h-16 text-${slide.color}`} />
        </div>

        <h1 className="text-3xl font-heading font-bold text-gray-900 mb-4">
          {slide.title}
        </h1>

        <p className="text-lg text-gray-600 mb-8 max-w-md whitespace-pre-line">
          {slide.description}
        </p>

        {/* Dots Indicator */}
        <div className="flex gap-2 mb-12">
          {slides.map((_, idx) => (
            <div
              key={idx}
              className={`h-2 rounded-full transition-all ${
                idx === currentSlide ? 'w-8 bg-primary' : 'w-2 bg-gray-300'
              }`}
            />
          ))}
        </div>

        {/* Next Button */}
        <button
          onClick={handleNext}
          className="w-full max-w-sm bg-primary hover:bg-primary-hover text-white font-semibold py-4 px-6 rounded-lg flex items-center justify-center gap-2 transition-colors"
        >
          {currentSlide < slides.length - 1 ? 'Next' : 'Get Started'}
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default Onboarding;